import { createContentFolderAction } from "fleet/redux-store/content-folders/actions";
import { MediaFolderCreateForm } from "fleet/view/media-library/folder-create-form";
import { connect } from "react-redux";

function mapDispatchToProps(dispatch) {
  return {
    createFolder: (folderName) => {
      dispatch(createContentFolderAction(folderName));
    },
  };
}

const ConnectedFolderCreateForm = connect(
  null,
  mapDispatchToProps,
)(MediaFolderCreateForm);

export { ConnectedFolderCreateForm };
